<template>
  <div class="chat-message" :class="chatMessageHeaderCSS()" :key="message.id">
    <div class="chat-message-header" v-if="full_message">
      <div>
        <a :href="authorUrl()">
         <user-avatar :user="author" :width="30" :height="30" />
        </a>
      </div>

      <div class="header-message-wrap">
        <div class="header-message-name-time-wrap">
          <div class="chat-message-name" :class="highlightUserHeaderCss()">
            <a class="chat-message-name-link"  :href="authorUrl()">
              {{ message.author_nickname }}
            </a>
          </div>
          <div class="chat-message-time">
            {{ message.created_at_time }}
          </div>
        </div>
        <div class="chat-message-content chat-message-content__header" :class="styleForBody()" v-linkified>
          <!---->{{ message.body }}<!---->
        </div>
      </div>
    </div>

    <div class="chat-message-content" :class="styleForBody()" v-linkified v-else>
      <!---->{{ message.body }}<!---->
    </div>

    <div class="chat-message-error" v-if="message.error">
      <a class="light-link" v-on:click.prevent="retryMessage()">
        <font-awesome-icon icon="redo" size="sm" />
        {{ I18n.t("common.buttons.retry") }}
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      message: Object,
      full_message: Boolean,
      author: Object,
      isAuthorCreator: Boolean
    },
    data: function() {
      return {
      }
    },
    methods: {
      authorUrl() {
        return `/users/${this.message.author_id}`
      },
      retryMessage() {
        this.$eventHub.$emit("retryMessage", this.message.id)
      },
      chatMessageHeaderCSS() {
        let headerCss = ""

        if (!this.message.viewed)
          headerCss += "not-viewed"

        if (this.full_message)
          headerCss += " chat-message__full"

        if (this.message.error)
          headerCss += " error"

        return headerCss
      },
      highlightUserHeaderCss() {
        if (!this.highlightUser)
          return ""
        return "creator-name"
      },
      styleForBody() {
        let styleClasses = '';
        if (this.isEmojiOnly(this.message.body)) {
          styleClasses += "only-emojis-message";
        }

        return styleClasses
      },
      isEmojiOnly(text) {
        // Regex to match emoji characters
        const emojiRegex = /^[\u{1F300}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F100}-\u{1F1FF}\u{1F200}-\u{1F2FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F900}-\u{1F9FF}\s]+$/u;
        return emojiRegex.test(text.trim());
      },
    }
  }
</script>

<style scoped>
  .chat-message {
    padding: 5px;
    font-size: 14px;
    position: relative;
/*
    @media only screen and (max-width: 600px) {
      font-size: 13px;
    }*/
  }

  .chat-message__full {
    margin-top: 15px;
  }

  .header-message-wrap {
    width: 100%;
  }

  .only-emojis-message {
    font-size: 35px;
  }

  .chat-message-error {
    position: absolute;
    top: 10px;
    right: 5px;
  }

  .chat-message-error a {
    text-transform: lowercase;
  }

  .creator-name a {
    color: #583f00 !important;
  }

  .not-viewed {
    background-color: whitesmoke;
    background-color: #f7f7f7;

  }

  .chat-message-header {
    display: flex;
  }

  .chat-message-header img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }

  .chat-message-name {
    font-weight: 600;
    word-break: break-word;
    margin-left: 9px;
    margin-right: 3px;
  }

  .chat-message-name a {
    color: #1d1c1d;
  }

  .error {
    background-color: #f3d3d3;
  }

  .chat-message-time {
    color: hsla(220,8%,51%,.6);
    font-size: 10px;
    z-index: 2;
    margin-left: 4px;
    line-height: 1.4;
  }

  .chat-message-content {
    margin-top: -9px;
    text-align: left;
    min-width: 1px;
    line-height: 1.26668;
    margin: 0px 0 3px;
    padding-left: 40px;
    white-space: pre-line;
    word-wrap: break-word;
    font-family: inherit;
  }

  .chat-message-content__header {
    padding-left: 10px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .header-message-name-time-wrap {
    display: flex;
    justify-content: start;
    align-items: center;
    margin-bottom: 6px;
  }
</style>
